import { el } from './dom.js';

/**
 * スマホ用のバーチャルスティック。
 * キーボードが無い端末で歩けるようにするためのもので、
 * 歩行モードのときだけ表示する。
 */
export function createJoystick(container, onChange) {
  const knob = el('div', { class: 'js-knob' });
  const base = el('div', { class: 'js-base' }, knob);
  const root = el('div', { class: 'js' }, base);
  container.appendChild(root);

  /** 追従中のポインタ。複数指でも1本だけ見る */
  let activeId = null;

  const radius = () => base.getBoundingClientRect().width / 2;

  function start(event) {
    if (activeId !== null) return;
    activeId = event.pointerId;
    base.setPointerCapture?.(event.pointerId);
    move(event);
  }

  function move(event) {
    if (activeId !== event.pointerId) return;
    const rect = base.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    const r = radius();

    let dx = (event.clientX - cx) / r;
    let dy = (event.clientY - cy) / r;
    const len = Math.hypot(dx, dy);
    if (len > 1) {
      dx /= len;
      dy /= len;
    }

    knob.style.transform = `translate(${dx * r * 0.6}px, ${dy * r * 0.6}px)`;
    // 画面の上方向が前進なので y は反転する
    onChange(dx, -dy);
  }

  function end(event) {
    if (activeId !== event.pointerId) return;
    activeId = null;
    knob.style.transform = '';
    onChange(0, 0);
  }

  base.addEventListener('pointerdown', start);
  base.addEventListener('pointermove', move);
  base.addEventListener('pointerup', end);
  base.addEventListener('pointercancel', end);

  return {
    setVisible(visible) {
      root.classList.toggle('is-open', visible);
      if (!visible) {
        activeId = null;
        knob.style.transform = '';
        onChange(0, 0);
      }
    },
  };
}
